import Cookies from 'universal-cookie';

class AuthCookie {
  static cookies = new Cookies();

  static setToken(value) {
    AuthCookie.cookies.set('token', value, { path: '/' });
  }

  static getToken() {
    return AuthCookie.cookies.get('token');
  }

  static removeToken() {
    AuthCookie.cookies.remove('token', { path: '/' });
  }

  static setAuthHost(value) {
    AuthCookie.cookies.set('authHost', value, { path: '/' });
  }

  static getAuthHost() {
    return AuthCookie.cookies.get('authHost');
  }

  static removeAuthHost() {
    AuthCookie.cookies.remove('authHost', { path: '/' });
  }

  static setLoginUrl(value) {
    AuthCookie.cookies.set('loginUrl', value, { path: '/' });
  }

  static getLoginUrl() {
    return AuthCookie.cookies.get('loginUrl');
  }

  static removeLoginUrl() {
    AuthCookie.cookies.remove('loginUrl', { path: '/' });
  }

  static setReturnUrl(value) {
    AuthCookie.cookies.set('returnUrl', value, { path: '/' });
  }

  static getReturnUrl() {
    return AuthCookie.cookies.get('returnUrl');
  }

  static removeReturnUrl() {
    AuthCookie.cookies.remove('returnUrl', { path: '/' });
  }
}

export default AuthCookie;



// WEBPACK FOOTER //
// ./src/api/AuthCookie.js